import { IGatsbyImageData } from 'gatsby-plugin-image';

export type OpportunitySalary = {
  upper?: number | undefined | null;
  lower?: number | undefined | null;
  currency: string;
  display?: string | null;
  ranges?: string[];
};

export enum OpportunityCurrency {
  GBP = 'GBP',
  EUR = 'EUR'
}

export type OpportunityType = {
  id: string;
  title: string;
};

export interface OpportunityDetails {
  opportunityStartDateDDMMYYYDotted: string | string[] | null;
  applicationDeadlineDDMMYYYDotted: string | null;
  showDaysLeft: boolean;
  daysLeft: number | null;
  salary: OpportunitySalary;
  applicationOpen: boolean;
}

export type OpportunityApplyBy = {
  id: string;
  title: string;
  url: string;
  orgId: string;
  orgName: string;
  orgLogo?: string;
  orgPath: string;
};
